<mat-form-field [class]="formFieldClass" class="input-container" [formGroup]="group" [appearance]="appearance">
  <mat-label *ngIf="label !== ''">{{label}}</mat-label>
  <mat-select [panelClass]="panelClass" [placeholder]="placeHolder" [formControl]="control" (valueChange)="onValueChange($event)" [disabled]="config?.disabled">
    <mat-option *ngFor="let item of data" [value]="item.value" >
      {{item.label}}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="control && control.touched && control.errors?.required">
    {{ errorMessage?.required ? errorMessage.required : fieldRequired() }}
  </mat-error>
</mat-form-field>
